import React from "react";
// import './index.css'

const PrivacyPolicy = () => {
    return (
        <div className="context">
            <h1>Privacy Policy</h1>
            <p className="text-paragraph">
                Vishwa Limited, along with our affiliates and group companies, (collectively, “Vishwa”) knows how
                important privacy is to our customers and wish to ensure you are informed about the manner in which we
                collect, use and share your personal data. Vishwa does collect, use, and disclose information in
                connection with your use of the services and access to the site, including when you use or interact with
                the services, register for or attend events, request to receive updates from Vishwa, complete a survey
                or questionnaire, participate in research, post in community features of the site, or otherwise
                communicate with us through any channel.
            </p>
            <div className="text-bold text-paragraph">
                <p>1. What information do we receive from you or collect?</p>
                <p>2. How We Use Information</p>
                <p>3. How We Share Information</p>
                <p>4. Access, Deletion, and Choice</p>
                <p>5. Contact</p>
            </div>

            <p className="text-bold">1.&nbsp;What information do we receive from you or collect?
            </p>
            <p className="text-paragraph">
                As used in this Privacy Policy, “personal information” means any information that identifies or could be
                used to identify an individual person. We understand your sensitivity regarding anonymity and aim to
                limit the collected data to protect your anonymity.
            </p>
            <p className="text-paragraph">
                The information and its type depend on the specific information you choose to give us.
            </p>


            <p className="text-bold">Information You Provide</p>
            <p className="text-bold text-paragraph">a.&nbsp;Identity Information:</p>
            <ul className="text-paragraph">
                <li>
                    Full Name
                </li>
                <li>
                    Username
                </li>
                <li>
                    Profile Picture
                </li>
                <li>
                    Other identifiers voluntarily provided by you
                </li>
            </ul>
            <p className="text-bold">
                b.&nbsp;Contact Information:
            </p>
            <ul className="text-paragraph">
                <li>
                    Email Address
                </li>
                <li>
                    Any additional contact details voluntarily provided by you
                </li>
            </ul>
            <p className="text-bold">
                c.&nbsp;Marketing Information:
            </p>
            <ul className="text-paragraph">
                <li>
                    Preferences, including opt-in preferences for receiving marketing communications
                </li>
                <li>
                    Your interaction patterns with our marketing communications
                </li>
            </ul>
            <p className="text-bold">
                d.&nbsp;User Communications:
            </p>
            <ul className="text-paragraph">
                <li>
                    Personal opinions
                </li>
                <li>
                    Information shared during inquiries, support requests, feedback submissions, survey responses, or
                    any other direct or indirect interactions with us
                </li>
            </ul>
            <p className="text-bold">
                e.&nbsp;Social Media Information:
            </p>
            <ul className="text-paragraph">
                <li>
                    Unique handle or identifier
                </li>
                <li>
                    Profile information associated with interactions on platforms such as Twitter, Discord, Slack,
                    Telegram, or any other relevant channels
                </li>
                <li>
                    Personal or business website address
                </li>

            </ul>
            <p className="text-bold text-paragraph">Data Acquired During Your Website Visits or Interaction with Our Services</p>

            <p className="text-bold">
                a.&nbsp;Log Files:
            </p>
            <ul className="text-paragraph">
                <li>
                    Information about your visit to our Website
                </li>
            </ul>
            <p className="text-bold">
                b.&nbsp;Cookies and Other Tracking Technologies:
            </p>
            <p className="text-paragraph">
                We, along with our third-party service providers or agents, may gather data through one or more cookies
                or similar technologies, such as pixels or locally stored objects, collectively referred to as
                “Cookies”. These Cookies may collect and store information such as:
            </p>
            <ul className="text-paragraph">
                <li>
                    your IP address,
                </li>
                <li>
                    unique device identifiers,
                </li>
                <li>
                    browser settings, and
                </li>
                <li>
                    details regarding your interaction with the services, including but not limited to the pages you
                    view and the links you click.
                </li>
            </ul>
            <p className="text-paragraph">
                For further details on our utilization of Cookies and your associated choices, kindly consult the&nbsp;<a
                href="https://policies.google.com/privacy?hl=en" style={{display: 'inline-block', color: '#fff', textDecoration: 'underline'}}>Privacy
                Policy</a>&nbsp;link of our third-party service
                provider Google Analytics.
            </p>
            <p className="text-bold">
                2.&nbsp;How We Use Information
            </p>
            <p className="text-paragraph">
                We use information pertaining to you for the following purposes:
            </p>
            <ul className="text-paragraph">
                <li>
                    Facilitating your access and utilization of specific services or features on the site.
                </li>
                <li>
                    Providing and delivering products, services, or experiences as per your requests.
                </li>
                <li>
                    Sustaining and enhancing the quality of the services and the site.
                </li>
                <li>
                    Tailoring your experience with the services and the site.
                </li>
                <li>
                    Coordinating events and furnishing event-related information.
                </li>
                <li>
                    Disseminating information, including technical notices, updates, security alerts, and administrative
                    communications.
                </li>
                <li>
                    Offering support for the services, addressing issues, and responding to your inquiries and feedback.
                </li>
                <li>
                    Adhering to legal obligations, including the collection, use, or retention of information, and
                    complying with legal requests such as subpoenas or government authorities’ directives.
                </li>
                <li>
                    Maintaining responsiveness to you, delivering effective services, and maintaining our business
                    relationship with you and others.
                </li>
                <li>
                    Marketing and promoting specific services, offerings, events, or experiences.
                </li>
                <li>
                    Preventing, detecting, and investigating fraudulent, abusive, or harmful activities.
                </li>
                <li>
                    Analyzing usage trends and evaluating the effectiveness of promotional or marketing campaigns.
                </li>
                <li>
                    Enforcing the other policies.
                </li>
            </ul>
            <p className="text-paragraph">
                We would like to express that your consent, whether obtained for processing based on consent or any
                other legal ground, will adhere strictly to the principles of lawfulness, fairness, transparency,
                purpose limitation, data minimization, accuracy, storage limitation, integrity, and confidentiality. In
                instances where personal information is collected and subsequently processed based on consent, you
                retain the right to withdraw your consent at any time. We will use this information for the purposes
                described in this Privacy Policy.
            </p>
            <p className="text-bold">
                3.&nbsp;How We Share Information
            </p>
            <p className="text-paragraph">
                As a part of a global industry, our operations span across borders, and we may transfer your personal
                information to affiliated companies within the Vishwa group or third parties located worldwide, aligning
                with the purposes outlined in the Privacy Policy. Irrespective of the destination where your personal
                information is transferred, stored, or processed by us, we are committed to taking the following
                reasonable steps to ensure the privacy and security of your personal information.
            </p>
            <p className="text-paragraph">
                Vishwa may disclose your personal data: (i) for the purposes outlined in “How We Use Information”,
                including within the Vishwa affiliated entities, (ii) as required by applicable law, (iii) in connection
                with Vishwa’s reorganization or combination, (iv) to enforce agreements, (v) to comply with legal
                obligations, and (vi) with your explicit consent when necessary.
            </p>
            <p className="text-bold">
                Business Transactions
            </p>
            <p className="text-paragraph">
                In the event of a merger, acquisition, or asset sale involving the Company, your Personal Data may be
                transferred. Please be assured, we will notify you beforehand, ensuring transparency and giving you the
                opportunity to familiarize yourself with any changes to the Privacy Policy that may apply to your
                Personal Data following the transfer.
            </p>
            <p className="text-bold">
                Affiliates
            </p>
            <p className="text-paragraph">
                We may share information about you with subsidiaries and affiliates of Vishwa for purposes consistent
                with this Privacy Policy.
            </p>
            <p className="text-bold">
                Security of You, Us, and Others
            </p>
            <p className="text-paragraph">
                We disclose information about you when we deem it necessary to comply with the law, enforce our Terms of
                Use, and other agreements with you, or safeguard the rights, property, or security of Vishwa, our
                agents, employees, or users. This may involve sharing information with other organisations for the
                purpose of fraud prevention and detection.
            </p>
            <p className="text-bold">
                Service Providers
            </p>
            <p className="text-paragraph">
                We may share your information with individuals and companies that help us run the services and the site.
                This includes marketing, event hosting, logistics planning, analytics, email delivery, and database
                management services. We also work with professional service providers like financial institutions,
                fiduciaries, law firms, accounting firms, insurers, and auditors who assist us in various ways.
            </p>
            <p className="text-bold">
                Legal, Compliance and Regulatory Necessities
            </p>
            <p className="text-paragraph">
                We may share personal information if we believe it's necessary to:
            </p>
            <ul className="text-paragraph">
                <li>
                    Comply with the law, regulations, legal processes, or legitimate government requests.
                </li>
                <li>
                    Protect the safety or security of the Services, users, or any person.
                </li>
                <li>
                    Investigate, prevent, or take action against illegal or suspected illegal activities.
                </li>
                <li>
                    Prevent spam, abuse, fraud, or malicious activities on the Services.
                </li>
                <li>
                    Protect our rights, property, or the rights/property of Services users.
                </li>
            </ul>
            <p style={{margin: '10px 0'}}>
                Non-public information about our users won't be disclosed to law enforcement, except in response to a
                proper legal process like a subpoena or court order. If there's an exigent emergency, we may provide
                information to law enforcement, determined case-by-case based on a good faith belief to prevent or
                mitigate danger.
            </p>
            <p className="text-bold">
                With Your Consent
            </p>
            <p className="text-paragraph">
                There may be situations where you are asked to consent to share personal information with third parties
                for additional reasons not included in this Privacy Policy.
            </p>
            <p className="text-bold">
                4.&nbsp;Access, Deletion, and Choice
            </p>
            <p className="text-paragraph">
                We retain personal information for the purposes stated in this Privacy Policy and as required under
                applicable law. To determine how long we keep personal information, we consider the amount, nature, and
                sensitivity of personal information, the reasons for which we collect and process the information, and
                applicable legal requirements.
            </p>
            <p>
                You have the right to:
            </p>
            <ul className="text-paragraph">
                <li>
                    Request information about how your data is processed, including purposes, categories, recipients,
                    and storage duration.
                </li>
                <li>
                    Receive your personal data in a structured, machine-readable format or transfer it to another
                    controller.
                </li>
                <li>
                    Correct incomplete data for processing purposes.
                </li>
                <li>
                    Request deletion or blocking of your data.
                </li>
                <li>
                    Restrict data processing.
                </li>
                <li>
                    Object to data processing.
                </li>
                <li>
                    Revoke consent for future processing.
                </li>
                <li>
                    Lodge a complaint with the supervisory authority for unauthorized data processing.
                </li>
            </ul>
            <p className="text-paragraph">
                If you need to update or delete specific information related to you or your interactions with the
                Services or the Site, feel free to contact us for assistance.
            </p>
            <p className="text-paragraph">
                You have choices regarding the collection and use of your information. You can opt not to provide
                certain details, but it may limit your ability to use certain services or access specific features of
                the Site.
            </p>
            <p>
                To manage your preferences:
            </p>
            <ul className="text-paragraph">
                <li>
                    For communications, you can unsubscribe or adjust your preferences.
                </li>
                <li>
                    On browsers and devices, use the help feature to control cookie settings, including accepting,
                    notifying, or disabling them.
                </li>
            </ul>
            <p className="text-bold">
                5.&nbsp;Contact
            </p>
            <p className="text-paragraph">
                Vishwa is the entity responsible for the processing of your Personal Information in connection with the
                Websites and Services. If you have any questions or comments about this Privacy Policy, our privacy
                practices, or if you would like to exercise your rights with respect to your Personal Information,
                please contact us by email at&nbsp;
                <a href="mailto:official@vishwanetwork.xyz"
                   style={{display: 'inline-block', color: '#fff', textDecoration: 'underline'}}>
                    official@vishwanetwork.xyz
                </a>
                .
            </p>
        </div>
    );
};

export default PrivacyPolicy;